import React from 'react';
import Label from '../Texts/Label/Label';
import * as S from './RadioButton.styles';
import PropTypes from 'prop-types';

const RadioButton = ({
  id,
  name,
  value,
  label,
  onChange,
  checked,
  border,
  disabled,
  align,
  status,
}) => {
  const renderMark = (
    <S.Mark
      htmlFor={id}
      align={align}
      border={border}
      disabled={disabled}
      status={status}
    />
  );
  return (
    <>
      <S.RadioButton border={border} disabled={disabled} align={align}>
        <S.InputRadioTag
          type='radio'
          id={id}
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          border={border}
          status={status}
        />
        {align === 'left' && renderMark}
        <Label
          id={id}
          type='2'
          cursor='pointer'
          variant='neutral'
          modifier={disabled ? 'regular' : 'strong'}
        >
          {label}
        </Label>
        {align === 'right' && renderMark}
        <S.RadioBorder
          htmlFor={id}
          border={border}
          data-testid='radio-border-data-test-id'
          disabled={disabled}
          status={status}
        />
      </S.RadioButton>
    </>
  );
};

RadioButton.defaultProps = {
  align: 'left',
  status: 'normal',
  border: false,
  disabled: false,
};

RadioButton.propTypes = {
  label: PropTypes.string,
  status: PropTypes.oneOf(['normal', 'error']),
  border: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  align: PropTypes.oneOf(['right', 'left']),
};

export default RadioButton;
